import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserLocalStoreService {

  save<T>(key: string, settings: T) {
    localStorage.setItem(key, JSON.stringify(settings));
  }

  get<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key) || '{}') as T;
  }

  delete(key: string) {
    localStorage.removeItem(key);
  }

}
